import apiClient from "../../../api/apiClient";
import { PaginationRequest } from "../../../models/Request/apiDateFormatRequest";
import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import { InboxMessageResponse } from "../models/response/InboxMessageResponse";

export const inboxApi = {
    getInboxMessages: async (
        request: PaginationRequest
    ): Promise<UnifiedResponse<InboxMessageResponse>> => {
        const response = await apiClient.post<UnifiedResponse<InboxMessageResponse>>(
            "/users/inbox/retrieve/list",
            request
        );
        return response.data;
    },

    readInboxMessage: async (request: { id: string }): Promise<UnifiedResponse<any>> => {
        const response = await apiClient.post<UnifiedResponse<any>>(
            "/users_inbox/update/status",
            request
        );
        return response.data
    },

    deleteInboxMessage: async (request: { id: string }): Promise<UnifiedResponse<any>> => {
        const response = await apiClient.post<UnifiedResponse<any>>(
            "/users/inbox/delete",
            request
        );
        return response.data;
    },

    readAllInboxMessages: async (request: {
        isAllRead: boolean;
    }): Promise<UnifiedResponse<any>> => {
        const response = await apiClient.post<UnifiedResponse<any>>(
            "/users_inbox/update/status",
            request
        );
        return response.data
    },
};